export enum CommonHcpWebPath {
  // Patient List
  PATIENT_LIST = '/patient/list',

  // Patient Overview
  PATIENT_OVERVIEW = '/patient/:userId/overview',

  // Patient Compliance
  PATIENT_COMPLIANCE = '/patient/:userId/compliance',

  // Patient RPM
  PATIENT_RPM_MODULE_PAGE = '/patient/:userId/rpm/:moduleCode',
  PATIENT_RPM_EVENT_DETAILS = '/patient/:userId/rpm/:formulaCode/event/:symptomEventId',
  PATIENT_HEALTH_EVENT_VIEW = '/patient/:userId/healthEvent/:healthEventId/view',
}
